function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMutation, useQuery } from "@apollo/client";
import { useHeaderHeight } from "@react-navigation/elements";
import { useFocusEffect, useNavigation, useRoute } from "@react-navigation/native";
import * as ScreenOrientation from "expo-screen-orientation";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import { createContext, Fragment, useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { Image, PixelRatio, Platform, StyleSheet, TouchableOpacity } from "react-native";
import { SystemBars } from "react-native-edge-to-edge";
import { getQuizSets } from "@oui/lib/src/getQuizSets";
import { graphql } from "@oui/lib/src/graphql/tada";
import { getMuxThumbnail, isMuxUrl } from "@oui/lib/src/muxUrl";
import { decodeHostedQuizSetSlug, isHostedQuizSetSlug } from "@oui/lib/src/quizSetSlug";
import { ProductVariant } from "@oui/lib/src/types";
import { ActivityIndicator } from "../components/ActivityIndicator";
import { Button } from "../components/Button";
import { CardStack, Card as CardStackCard } from "../components/CardStack";
import { CheckboxListInput } from "../components/CheckboxListInput";
import { HeaderButtons, HeaderItem } from "../components/HeaderButtons";
import { Icon } from "../components/Icon";
import { MediaPlayer } from "../components/MediaPlayer";
import { RadioInput } from "../components/RadioInput";
import { ReviewCompleteCard } from "../components/ReviewCompleteCard";
import { RoundedSection } from "../components/RoundedSection";
import { ScrollView } from "../components/ScrollView";
import { Text } from "../components/Text";
import { View } from "../components/View";
import { useArtifactRequest } from "../hooks/useArtifactResult";
import { useCurrentPatientID, useCurrentUser } from "../hooks/useCurrentUser";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import { CHAT_PREVIEW_BORDER_RADIUS, useTheme } from "../styles";
var CompletedQuizSetsQueryName = 'CompletedQuizSets';
var CompletedQuizSetsQuery = graphql("\n  query CompletedQuizSets($input: CompletedQuizSetsForPatientInput!) {\n    completedQuizSetsForPatient(input: $input) {\n      patientID\n      completedQuizSets {\n        quizSetID\n        slug\n      }\n    }\n  }\n");
export var CompleteQuizSetMutation = graphql("\n  mutation CompleteQuizSet($input: CompleteQuizSetForPatientInput!) {\n    completeQuizSetForPatient(input: $input) {\n      patientID\n      completedQuizSet {\n        quizSetID\n        slug\n      }\n    }\n  }\n");
export var QuizSetCollectionQuery = graphql("\n  query QuizSetCollection($quizSetCollectionID: UUID!) {\n    quizSetCollectionByID(quizSetCollectionID: $quizSetCollectionID) {\n      quizSetCollectionID\n      sets {\n        quizSetID\n        ID\n        name\n        description\n        previewTime\n        previewOptions {\n          time\n          height\n          fitMode\n        }\n        items: legacyItems {\n          __typename\n          ... on LegacyQuizSetItemVideo {\n            props {\n              url\n            }\n          }\n          ... on LegacyQuizSetItemMultipleChoiceQuestion {\n            props {\n              label\n            }\n            dir {\n              feedback\n              prompt\n              afterAll\n            }\n          }\n          ... on LegacyQuizSetItemSingleChoiceQuestion {\n            props {\n              label\n            }\n            dir {\n              feedback\n              prompt\n              afterAll\n            }\n          }\n        }\n      }\n    }\n  }\n");
var QUIZ_SET_PADDING_VERTICAL = 20;
function getQuizSetPaddingHorizontal(param) {
    var height = param.height, width = param.width;
    var consumedHeight = // card stack
    QUIZ_SET_PADDING_VERTICAL + // card stack vertical position of active card
    20 + // card stack page index + arrows 30 (w/marginTop of 20)
    50;
    var horizontalPadding = 20;
    for(var i = 0; i < 60; i = i + 5){
        horizontalPadding = 20 + i;
        var resultingAspectRatio = (width - horizontalPadding * 2) / (height - consumedHeight);
        if (resultingAspectRatio < 9 / 16) {
            return horizontalPadding;
        }
    }
    return horizontalPadding;
}
function QuizSetItemVideoCard(_param) {
    var item = _param.item, rest = _object_without_properties(_param, [
        "item"
    ]);
    var cardProps = rest;
    var isActive = cardProps.index === cardProps.animatedIndex.value;
    return /*#__PURE__*/ _jsx(CardStackCard, _object_spread_props(_object_spread({}, rest), {
        _disableGesture: true,
        _padding: 0,
        children: /*#__PURE__*/ _jsx(View, {
            testID: "QuizSetItemVideoCard",
            style: {
                borderRadius: 16,
                overflow: 'hidden',
                width: '100%',
                // depending on aspect ratio of screen, our video may be too large since MediaPlayer's internal
                // height detection mechanism doesn't work unless we set a height here since the card
                // is position absolute. using width + aspectRatio, we force the right height for this view
                // by using getQuizSetPaddingHorizontal to dynamically force/calculate the card's width,
                // we can be assured we'll get a good fit with 9/16
                aspectRatio: 9 / 16
            },
            children: isActive ? /*#__PURE__*/ _jsx(MediaPlayer, {
                _enableSkipToEnd: global.e2e,
                // detox has trouble synchronizing on android when video autoplays... so a workaround is to
                // disable autoplay in this case
                autoPlay: !(global.e2e && Platform.OS === 'android'),
                uri: item.props.url,
                onClose: undefined,
                onEnd: function() {
                    var _cardProps_next;
                    (_cardProps_next = cardProps.next) === null || _cardProps_next === void 0 ? void 0 : _cardProps_next.call(cardProps);
                },
                aspectRatio: 9 / 16,
                resizeMode: "cover"
            }) : null
        })
    }));
}
function Feedback(param) {
    var feedback = param.feedback, afterAll = param.afterAll;
    var theme = useTheme().theme;
    var afterText = afterAll ? [
        feedback.text,
        afterAll
    ].join('\n\n').trim() : feedback.text;
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            backgroundColor: feedback.correct ? '#f4f8f5' : '#f7f7f9',
            paddingVertical: 20,
            paddingHorizontal: 32,
            marginHorizontal: -20,
            borderBottomWidth: 1,
            borderTopWidth: feedback.correct ? 0 : 1,
            borderColor: '#C5C5D3'
        },
        spacing: 14,
        children: [
            feedback.correct ? /*#__PURE__*/ _jsxs(View, {
                row: true,
                spacing: 14,
                testID: "QuizSetCard_correctFeedback",
                children: [
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            backgroundColor: 'rgba(18, 137, 24, 0.2)',
                            borderRadius: 35,
                            height: 35,
                            width: 35,
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'center'
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            name: "check",
                            color: "#035759",
                            "aria-label": undefined,
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        text: "That's right",
                        size: 17,
                        weight: "semibold",
                        color: "#035759"
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(View, {
                row: true,
                spacing: 14,
                testID: "QuizSetCard_incorrectFeedback",
                children: [
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            backgroundColor: 'rgba(206, 106, 107, 0.2)',
                            borderRadius: 35,
                            height: 35,
                            width: 35,
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'center'
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            name: "close",
                            color: theme.color.danger,
                            "aria-label": undefined,
                            size: 14
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        text: "Not quite",
                        size: 17,
                        weight: "semibold",
                        color: theme.color.danger
                    })
                ]
            }),
            afterText ? /*#__PURE__*/ _jsx(Text, {
                text: afterText,
                size: 17,
                weight: "semibold"
            }) : null
        ]
    });
}
function QuizSetItemSingleChoiceCard(_param) {
    var item = _param.item, rest = _object_without_properties(_param, [
        "item"
    ]);
    var cardProps = rest;
    var _useState = _sliced_to_array(useState(''), 2), value = _useState[0], setValue = _useState[1];
    var feedback = item.dir.feedback[value];
    return /*#__PURE__*/ _jsxs(CardStackCard, _object_spread_props(_object_spread({}, rest), {
        _disableGesture: true,
        children: [
            /*#__PURE__*/ _jsx(RadioInput, {
                testID: "QuizSetItemSingleChoiceCard_input",
                items: Object.entries(item.props.label).map(function(param) {
                    var _$_param = _sliced_to_array(param, 2), key = _$_param[0], label = _$_param[1];
                    return {
                        label: label,
                        value: key
                    };
                }),
                onChangeValue: setValue,
                value: value,
                "aria-label": item.dir.prompt,
                labelSize: "large",
                labelSpacing: 40,
                label: item.dir.prompt
            }),
            /*#__PURE__*/ _jsxs(View, {
                spacing: 12,
                children: [
                    feedback ? /*#__PURE__*/ _jsx(Feedback, {
                        feedback: feedback,
                        afterAll: item.dir.afterAll
                    }) : null,
                    value ? /*#__PURE__*/ _jsx(Button, {
                        text: "Next",
                        onPress: cardProps.next,
                        alignSelf: "center",
                        testID: "QuizSetItemSingleChoiceCard_nextButton"
                    }) : null
                ]
            })
        ]
    }));
}
function QuizSetItemMultipleChoiceCard(_param) {
    var item = _param.item, rest = _object_without_properties(_param, [
        "item"
    ]);
    var cardProps = rest;
    var _useState = _sliced_to_array(useState([]), 2), value = _useState[0], setValue = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), submitted = _useState1[0], setSubmitted = _useState1[1];
    var _item_dir_feedback_JSON_stringify;
    var feedback = submitted && ((_item_dir_feedback_JSON_stringify = item.dir.feedback[JSON.stringify(_to_consumable_array(value).sort())]) !== null && _item_dir_feedback_JSON_stringify !== void 0 ? _item_dir_feedback_JSON_stringify : item.dir.feedback.default);
    return /*#__PURE__*/ _jsxs(CardStackCard, _object_spread_props(_object_spread({}, rest), {
        _disableGesture: true,
        children: [
            /*#__PURE__*/ _jsx(CheckboxListInput, {
                testID: "QuizSetItemMultipleChoiceCard_input",
                label: item.dir.prompt,
                items: item.props.label,
                value: value,
                onChangeValue: function(v) {
                    setValue(v);
                    if (submitted) setSubmitted(false);
                }
            }),
            /*#__PURE__*/ _jsxs(View, {
                spacing: 12,
                children: [
                    feedback ? /*#__PURE__*/ _jsx(Feedback, {
                        feedback: feedback,
                        afterAll: item.dir.afterAll
                    }) : null,
                    submitted ? /*#__PURE__*/ _jsx(Button, {
                        text: "Next",
                        onPress: cardProps.next,
                        alignSelf: "center",
                        testID: "QuizSetItemMultipleChoiceCard_nextButton"
                    }) : /*#__PURE__*/ _jsx(Button, {
                        text: "Choose",
                        onPress: function() {
                            return setSubmitted(true);
                        },
                        alignSelf: "center",
                        testID: "QuizSetItemMultipleChoiceCard_chooseButton"
                    })
                ]
            })
        ]
    }));
}
function getQuizSetPreviewUrl(set, options) {
    var _set_items_find;
    var setVideoUrl = (_set_items_find = set.items.find(function(i) {
        return i.__typename === 'LegacyQuizSetItemVideo';
    })) === null || _set_items_find === void 0 ? void 0 : _set_items_find.props.url;
    return isMuxUrl(setVideoUrl) ? getMuxThumbnail(setVideoUrl, options) : undefined;
}
// This is exposed via context because in collaborative onboarding (MyStoryMyPlanStack) we render
// a PatientView while logged in as the clinician. In order to show the correct quiz sets, we must
// know which productVariant the clinician's patient has
export var QuizSetProductVariantContext = /*#__PURE__*/ createContext(ProductVariant.AVIVA_ADULT);
function useLocalQuizSets(slug) {
    var _data_user_role, _data_user;
    var defaultProductVariant = useContext(QuizSetProductVariantContext);
    var data = useCurrentUser().data;
    var _data_user_role_product_slug;
    var productSlug = (_data_user_role_product_slug = data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : (_data_user_role = _data_user.role) === null || _data_user_role === void 0 ? void 0 : _data_user_role.product.slug) !== null && _data_user_role_product_slug !== void 0 ? _data_user_role_product_slug : defaultProductVariant;
    var sets = productSlug ? getQuizSets({
        slug: slug,
        productSlug: productSlug
    }) : [];
    return {
        sets: sets,
        loading: false
    };
}
function useHostedQuizSets(variables) {
    var _useQuery = useQuery(QuizSetCollectionQuery, {
        variables: variables
    }), data = _useQuery.data, loading = _useQuery.loading;
    var _data_quizSetCollectionByID_sets;
    // temporary coercion until we can remove static SetData (currently incompatible b/c gql
    // data has __typename and quizSetID
    var sets = (_data_quizSetCollectionByID_sets = data === null || data === void 0 ? void 0 : data.quizSetCollectionByID.sets) !== null && _data_quizSetCollectionByID_sets !== void 0 ? _data_quizSetCollectionByID_sets : [];
    return {
        sets: sets,
        loading: loading
    };
}
function useQuizSets(slug) {
    if (isHostedQuizSetSlug(slug)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useHostedQuizSets(decodeHostedQuizSetSlug(slug));
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useLocalQuizSets(slug);
}
/**
 * @nosync
 */ export function QuizSetPreview(props) {
    var _useTheme = useTheme(), theme = _useTheme.theme, Shadow = _useTheme.Shadow;
    var sets = useQuizSets(props.slug).sets;
    if (sets.length === 0) return null;
    // TODO this should move to preview options
    var format = props.slug.includes('VOICEOVER') ? 'png' : 'jpg';
    var images = sets.map(function(s, i) {
        var width = Math.floor(sets.length > 1 ? props.width / 2 : props.width);
        var height = Math.floor(sets.length > 2 ? props.height / 2 : props.height);
        if (i === 2 && sets.length === 3) {
            width = props.width;
        }
        var _s_previewTime;
        return {
            url: getQuizSetPreviewUrl(s, _object_spread_props(_object_spread({
                format: format,
                time: (_s_previewTime = s.previewTime) !== null && _s_previewTime !== void 0 ? _s_previewTime : 5,
                width: width,
                height: height
            }, omitBy(s.previewOptions, isNil)), {
                getPixelSizeForLayoutSize: PixelRatio.getPixelSizeForLayoutSize
            })),
            width: width,
            height: height
        };
    }).filter(function(u) {
        return !!u.url;
    }).slice(0, 4);
    return /*#__PURE__*/ _jsxs(View, {
        row: true,
        style: {
            flexWrap: 'wrap',
            width: props.width,
            borderRadius: CHAT_PREVIEW_BORDER_RADIUS,
            overflow: 'hidden'
        },
        children: [
            images.map(function(image, i) {
                return /*#__PURE__*/ _jsx(Image, {
                    source: {
                        uri: image.url
                    },
                    style: {
                        height: image.height,
                        width: image.width
                    }
                }, image.url + i);
            }),
            /*#__PURE__*/ _jsx(View, {
                style: [
                    _object_spread_props(_object_spread({}, StyleSheet.absoluteFillObject), {
                        alignItems: 'center',
                        justifyContent: 'center'
                    }),
                    Shadow.high
                ],
                children: /*#__PURE__*/ _jsx(View, {
                    style: {
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 50,
                        height: 50,
                        backgroundColor: 'rgba(255,255,255,0.8)',
                        borderRadius: 50 / 2
                    },
                    children: /*#__PURE__*/ _jsx(Icon, {
                        color: theme.color.primary100,
                        name: "play",
                        size: 30
                    })
                })
            })
        ]
    });
}
/**
 * Displays `QuizSet` content to the user for the requested `slug` which should
 * match a `ContentType`.
 *
 *
 *
 * ### Video + quiz sets
 *
 * We have two types of video content in chatbot sessions: VOs and vignettes.
 *
 *
 *
 * Every VO and vignette can have multiple videos and quiz questions that we’d
 * like to show together in a set or a series.
 *
 *
 *
 * Each set of videos + quiz questions is arranged into a card UI stack similar
 * to the thought diary or sleep diary. One set is a one stack of cards.
 *
 * ### One or many sets
 *
 * Right now, we’re in the process of producing one version of VO videos and
 * multiple vignette character videos. This means in each session VOs will have
 * one video + quiz set and vignettes will have many (most likely 4) video +
 * quiz sets (one per character).
 *
 *
 *
 * **Set definition**
 *
 * We define a set as a series of videos and quizzes.
 *
 * An example of a set can be:
 *
 * 1. Video A
 * 2. Quiz question about video A
 * 3. Video B
 * 4. Quiz question about video B
 * 5. Quiz question about video B
 * 6. Video C
 * 7. Quiz question about video C
 *
 * This is one stack of cards.
 *
 *
 *
 * One set is a one stack of cards. VOs have one set. Vignettes have one set per
 * character.
 *
 *
 *
 * **Default state of one set**
 *
 * When the video widget has one set, the default state is that set’s card UI
 * stack.
 *
 *
 *
 * **Default state of many sets**
 *
 * When the video widget has many sets, the default state is an index page where
 * the patient is able to browse and select which set to watch.
 *
 *
 *
 * *Video index page*
 *
 * The index page shows an image representing each set with a 70 character
 * description. When a set is completed, a completed label appears under the
 * image on the index page.
 *
 *
 *
 * ### Quiz questions
 *
 * Right now, each quiz question is a radio choice. When the patient selects
 * their answer it can only be right or wrong.
 *
 *
 *
 * **Right answers**
 *
 * If the answer is right, a green background panel will appear with a green
 * checkmark and specific copy to that right answer.
 *
 *
 *
 * **Wrong answer**
 *
 * If the answer is wrong, a pale red background panel will appear with a red
 * “X” and specific copy explaining why that answer is wrong and what the right
 * one would be.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-144}
 */ export function QuizSet(props) {
    var patientID = useCurrentPatientID();
    var _useWindowDimensions = useWindowDimensions(), width = _useWindowDimensions.width, height = _useWindowDimensions.height;
    var headerHeight = useHeaderHeight();
    var theme = useTheme().theme;
    var _useNavigation = useNavigation(), goBack = _useNavigation.goBack, setOptions = _useNavigation.setOptions;
    var route = useRoute();
    var params = route.params;
    var _props_slug;
    var slug = (_props_slug = props.slug) !== null && _props_slug !== void 0 ? _props_slug : params.slug;
    var _useQuizSets = useQuizSets(slug), sets = _useQuizSets.sets, loading = _useQuizSets.loading;
    var defaultTitle = params.slug.includes('LEARN') ? 'Learn' : params.slug.includes('APPLY') ? 'Apply' : 'Watch';
    var completedRef = useRef(false);
    var completeQuizSetSlug = slug;
    if (isHostedQuizSetSlug(slug)) {
        var decoded = decodeHostedQuizSetSlug(slug);
        completeQuizSetSlug = decoded.quizSetCollectionID;
    }
    var onDone = function() {
        if (props.onDone) {
            props.onDone();
        } else {
            goBack();
        }
    };
    var _useState = _sliced_to_array(useState('0'), 2), cardStackKey = _useState[0], setCardStackKey = _useState[1];
    var _useState1 = _sliced_to_array(useState(sets.length === 1 ? sets[0].ID : ''), 2), selectedSetID = _useState1[0], setSelectedSetID = _useState1[1];
    var _useQuery = useQuery(CompletedQuizSetsQuery, {
        skip: !patientID,
        variables: {
            input: {
                patientID: patientID,
                slug: completeQuizSetSlug
            }
        }
    }), completedQuizSets = _useQuery.data;
    var completedSetIDs = useMemo(function() {
        var _completedQuizSets_completedQuizSetsForPatient_completedQuizSets_map;
        return (_completedQuizSets_completedQuizSetsForPatient_completedQuizSets_map = completedQuizSets === null || completedQuizSets === void 0 ? void 0 : completedQuizSets.completedQuizSetsForPatient.completedQuizSets.map(function(qs) {
            return qs.quizSetID;
        })) !== null && _completedQuizSets_completedQuizSetsForPatient_completedQuizSets_map !== void 0 ? _completedQuizSets_completedQuizSetsForPatient_completedQuizSets_map : [];
    }, [
        completedQuizSets
    ]);
    var _useMutation = _sliced_to_array(useMutation(CompleteQuizSetMutation), 1), completeQuizSet = _useMutation[0];
    var complete = completedRef.current || completedSetIDs.length > 0;
    var selectedSet = sets.find(function(d) {
        return d.ID === selectedSetID;
    });
    useFocusEffect(useCallback(function() {
        if (Platform.OS !== 'web') {
            void ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);
        }
        return function() {
            if (Platform.OS !== 'web') {
                void ScreenOrientation.unlockAsync();
            }
        };
    }, []));
    useLayoutEffect(function() {
        // if loading is required, we may not know sets.length when initializing useState
        if (sets.length === 1) {
            setSelectedSetID(sets[0].ID);
        }
    }, [
        sets
    ]);
    useArtifactRequest(route.name, complete);
    var title = selectedSet === null || selectedSet === void 0 ? void 0 : selectedSet.name;
    useEffect(function() {
        if (selectedSetID) {
            setOptions({
                headerTitle: title,
                headerTitleAlign: 'center',
                headerLeft: sets.length > 1 ? function(param) {
                    var tintColor = param.tintColor;
                    return /*#__PURE__*/ _jsx(HeaderButtons, {
                        children: /*#__PURE__*/ _jsx(HeaderItem, {
                            "aria-label": "Cancel",
                            title: "",
                            onPress: function() {
                                setSelectedSetID('');
                            },
                            iconName: "close",
                            color: tintColor,
                            testID: "QuizSet_cancelButton"
                        })
                    });
                } : undefined
            });
        } else {
            setOptions({
                headerLeft: undefined,
                headerTitle: ''
            });
        }
    }, [
        selectedSetID,
        setOptions,
        sets.length,
        title
    ]);
    if (selectedSet) {
        return /*#__PURE__*/ _jsxs(ScrollView, {
            style: {
                flex: 1,
                backgroundColor: 'black'
            },
            contentContainerStyle: {
                paddingHorizontal: getQuizSetPaddingHorizontal({
                    width: width,
                    height: height - headerHeight
                }),
                paddingVertical: QUIZ_SET_PADDING_VERTICAL,
                flexGrow: 1
            },
            testID: "QuizSet_selectedSet",
            children: [
                /*#__PURE__*/ _jsx(SystemBars, {
                    style: "light"
                }),
                /*#__PURE__*/ _jsxs(CardStack, {
                    hideNextButtonIndexes: true,
                    pageColor: "white",
                    hasCompleteCard: true,
                    children: [
                        selectedSet.items.map(function(c, i) {
                            switch(c.__typename){
                                case 'LegacyQuizSetItemVideo':
                                    return /*#__PURE__*/ _jsx(QuizSetItemVideoCard, {
                                        item: c
                                    }, i);
                                case 'LegacyQuizSetItemSingleChoiceQuestion':
                                    return /*#__PURE__*/ _jsx(QuizSetItemSingleChoiceCard, {
                                        item: c
                                    }, i);
                                case 'LegacyQuizSetItemMultipleChoiceQuestion':
                                    return /*#__PURE__*/ _jsx(QuizSetItemMultipleChoiceCard, {
                                        item: c
                                    }, i);
                            }
                        }),
                        /*#__PURE__*/ _jsx(ReviewCompleteCard, {
                            text: "Complete",
                            onDone: function() {
                                if (sets.length > 1) {
                                    setSelectedSetID('');
                                } else {
                                    onDone();
                                }
                            },
                            onReset: function() {
                                return setCardStackKey(function(k) {
                                    return k + '1';
                                });
                            },
                            onActive: function() {
                                completedRef.current = true;
                                void completeQuizSet({
                                    variables: {
                                        input: {
                                            slug: completeQuizSetSlug,
                                            quizSetID: selectedSetID,
                                            patientID: patientID
                                        }
                                    },
                                    refetchQueries: [
                                        CompletedQuizSetsQueryName
                                    ]
                                });
                            },
                            resetText: "Reset"
                        })
                    ]
                }, selectedSetID + cardStackKey)
            ]
        });
    }
    return /*#__PURE__*/ _jsx(RoundedSection, {
        color: "black",
        secondaryColor: loading ? 'black' : 'white',
        title: loading ? ' ' : params.title || defaultTitle,
        preview: props.preview,
        testID: "QuizSet",
        children: loading ? /*#__PURE__*/ _jsx(ActivityIndicator, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    text: "Choose someone",
                    size: 21,
                    weight: "bold",
                    textAlign: "center",
                    style: {
                        marginTop: 20,
                        marginBottom: 40
                    }
                }),
                /*#__PURE__*/ _jsxs(View, {
                    spacing: 60,
                    children: [
                        sets.map(function(set, i) {
                            var onPress = function() {
                                return setSelectedSetID(set.ID);
                            };
                            var label = "Watch ".concat(set.name);
                            var _set_previewTime;
                            var muxUrl = getQuizSetPreviewUrl(set, {
                                time: (_set_previewTime = set.previewTime) !== null && _set_previewTime !== void 0 ? _set_previewTime : 5,
                                format: params.slug.includes('VOICEOVER') ? 'png' : 'jpg',
                                width: 156,
                                height: 125,
                                getPixelSizeForLayoutSize: PixelRatio.getPixelSizeForLayoutSize
                            });
                            var isComplete = completedSetIDs.includes(set.ID);
                            return /*#__PURE__*/ _jsx(Fragment, {
                                children: /*#__PURE__*/ _jsx(TouchableOpacity, {
                                    role: "button",
                                    "aria-label": label,
                                    onPress: onPress,
                                    testID: "QuizSet_item_".concat(i),
                                    children: /*#__PURE__*/ _jsxs(View, {
                                        row: true,
                                        spacing: 22,
                                        children: [
                                            /*#__PURE__*/ _jsxs(View, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(View, {
                                                        style: {
                                                            borderRadius: CHAT_PREVIEW_BORDER_RADIUS,
                                                            borderWidth: 2,
                                                            borderColor: theme.color.primary100,
                                                            backgroundColor: '#eee',
                                                            height: 125 + 4,
                                                            width: 156 + 4,
                                                            overflow: 'hidden'
                                                        },
                                                        children: muxUrl ? /*#__PURE__*/ _jsx(Image, {
                                                            source: {
                                                                uri: muxUrl
                                                            },
                                                            style: {
                                                                height: 125,
                                                                width: 156
                                                            }
                                                        }) : null
                                                    }),
                                                    /*#__PURE__*/ _jsx(View, {
                                                        flex: 1,
                                                        style: [
                                                            {
                                                                marginTop: 5,
                                                                alignItems: 'center',
                                                                marginBottom: -28
                                                            },
                                                            isComplete ? null : {
                                                                display: 'none'
                                                            }
                                                        ],
                                                        "aria-hidden": isComplete,
                                                        testID: isComplete ? "QuizSet_item_".concat(i, "_completed") : undefined,
                                                        children: /*#__PURE__*/ _jsxs(View, {
                                                            row: true,
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Icon, {
                                                                    name: "check",
                                                                    color: "#035759",
                                                                    size: 24
                                                                }),
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    text: "Completed",
                                                                    color: "#035759",
                                                                    weight: "semibold"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(View, {
                                                flex: 1,
                                                spacing: 15,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Text, {
                                                        text: set.description,
                                                        style: {
                                                            flex: 1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        onPress: onPress,
                                                        text: label,
                                                        variant: "text",
                                                        icon: "play"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, set.ID);
                        }),
                        complete ? /*#__PURE__*/ _jsx(Button, {
                            text: "Done",
                            onPress: onDone,
                            alignSelf: "center"
                        }) : null
                    ]
                })
            ]
        })
    });
}
